import { SignupFormData } from 'modules/auth/hooks/useSignupForm'
import { Checkbox } from 'modules/common/components/_ui/FormControl/Checkbox/Checkbox'
import { Message } from 'modules/common/components/_ui/Message/Message'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { Trans } from 'react-i18next'

export const SignupFormPasswordFieldOptionalConsentCheckbox = () => {
  const { t } = useTranslation('auth-components')

  const { control, setValue, watch } = useFormContext<SignupFormData>()

  const allOptionalConsent = watch('allOptionalConsent')

  useEffect(() => {
    setValue('hasConsentedForMarketing', allOptionalConsent)
    setValue('hasConsentedForThirdPartyCommunication', allOptionalConsent)
  }, [allOptionalConsent, setValue])

  return (
    <Message
      content={
        <>
          <Checkbox
            control={control}
            id="allOptionalConsent"
            name="allOptionalConsent"
            labelClassName={'text-base text-info-600 w-full h-full'}
            label={
              <Trans parent="p">
                {t('signupForm.password.allOptionalConsentLabel')}
              </Trans>
            }
          />
          <div className="ml-4">
            <Checkbox
              control={control}
              id="hasConsentedForMarketing"
              name="hasConsentedForMarketing"
              labelClassName={'text-base text-info-600 w-full h-full'}
              label={
                <Trans parent="p">
                  {t('signupForm.password.hasConsentedForMarketingLabel')}
                </Trans>
              }
            />
            <Checkbox
              control={control}
              id="hasConsentedForThirdPartyCommunication"
              name="hasConsentedForThirdPartyCommunication"
              labelClassName={'text-base text-info-600 w-full h-full'}
              label={
                <Trans parent="p">
                  {t(
                    'signupForm.password.hasConsentedForThirdPartyCommunicationLabel'
                  )}
                </Trans>
              }
            />
          </div>
        </>
      }
    />
  )
}
